import { BEGINNER_VILLAGE } from './beginner-village.js';
import type { ZoneDef } from './types.js';

export * from './types.js';
export * from './layout.js';
export { BEGINNER_VILLAGE };

export const ZONES: Readonly<Record<string, ZoneDef>> = {
  [BEGINNER_VILLAGE.id]: BEGINNER_VILLAGE,
};

export const STARTING_ZONE_ID = BEGINNER_VILLAGE.id;

export function getZone(id: string): ZoneDef | undefined {
  return ZONES[id];
}
